import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="notfound-wrap">
            <h1>404</h1>
            <p>Stran ni bila najdena.</p>
            <Link to="/vpis">Nazaj na prijavo</Link>
        </div>
    );
}
